import { createContext } from "react";
import { TScreen, TScreenContext } from "api/type";

// Create context with initial state
const ScreenContext = createContext<TScreenContext>([TScreen.NONE, () => {}]);

export default ScreenContext;
